/**
 * DEFA Pagination Strip
 * A pagination plugin for the Simplify application.
 *
 * @version 0.9.0
 *
 */
import { T } from 'defa-object';

const selectors = {
	button   : '[data-click=pagination-button]',
	container: '[data-container=pagination-strip]',
	
};

const PaginationStrip = function ( application, options ) {
	// options is an object
	options = options || {};
	
	// setup vars
	let defaults = {
			currentPage: 9,
			totalPages : 10,
		},
		settings,
	
		$app,
		$container;
	
	/**
	 * @constructor
	 */
	let init = function () {
		// add the defaults to the settings
		settings = _.extend( {}, defaults );
		
		// setup application objects
		$app       = $( application );
		$container = $app.find( selectors.container );
		
		// initialize settings
		_settings( options );
	};
	
	// -------------------------------------------
	// event handlers
	// -------------------------------------------
	
	/**
	 * Triggers when an end user click any pagination button.
	 * @void
	 */
	let onClickButton = function ( event ) {
		event.preventDefault();
		
		let $target = $( event.target ).closest( selectors.button ),
			id      = $target.attr( 'data-id' );
		
		// as long at target isn't active or disabled, trigger the click.
		if ( !$target.parent().hasClass( 'active' ) && $target.attr( 'disabled' ) !== 'disabled' ) {
			$app.trigger( 'change', id );
		}
		
	};
	
	// -------------------------------------------
	// public functions
	// -------------------------------------------
	
	/**
	 * Public method of re-initializing the plugin, building new buttons and new listeners.
	 * @param   {object}  Options  New settings, will override any old setting per variable. (optional)
	 * @returns {object}           The current settings, after merge with any new setting.
	 */
	this.settings = function ( options ) {
		_settings( options );
		
	};
	
	
	// -------------------------------------------
	// private functions
	// -------------------------------------------
	
	// plugin control
	
	/**
	 * Updates the settings of the plugin.
	 * @param   {object}  Options  New settings, will override any old setting per variable. (optional)
	 * @returns {object}           The current settings, after merge with any new setting.
	 */
	let _settings = function ( options ) {
		
		if ( options ) {
			settings = _.extend( settings, options );
			_setup();
		}
		
		return settings;
		
	};
	
	/**
	 * Triggers a new setup of the pagination block, builds new buttons, attaches new listeners.
	 * @void
	 */
	let _setup = function () {
		
		// parse the pages into a pagination object representing the buttons.
		let arrPagination = _createPaginationItems(),
			html5         = _createPaginationHtml( arrPagination );
		
		$container.html( html5 );
		
		_attachListeners();
		
	};
	
	/**
	 * Attaches listeners to new html-buttons.
	 * @void
	 */
	let _attachListeners = function () {
		
		$app.find( selectors.button ).on( 'click', onClickButton );
	};
	
	
	// pagination indices list
	
	/**
	 * Creates an array of pagination items used for making html.
	 * @return {array}  An array of pagination items.
	 */
	let _createPaginationItems = function () {
		
		let arr = [];
		// create indexex up to settings.totalPages
		if ( settings.totalPages <= 9 ) {
			
			arr = _.times( settings.totalPages, function ( n ) {
				return _createPaginationIndex( n );
			} );
			
			// create first/prev + up to 5 indexes + next/last
		} else {
			
			// first button
			arr.push( _createPaginationIndex( 'first' ) );
			
			// prev button
			arr.push( _createPaginationIndex( 'prev' ) );
			
			// five middle buttons
			let nIndex = _extimateStartIndex();
			for ( let i = 0; i < 5; i++ ) {
				arr.push( _createPaginationIndex( nIndex ) );
				nIndex++;
			}
			
			// next button
			arr.push( _createPaginationIndex( 'next' ) );
			
			// last button
			arr.push( _createPaginationIndex( 'last' ) );
			
		}
		
		
		return arr;
		
	};
	
	/**
	 * Estimates a button start index based on currentPage and totalPages.
	 * @return {int}  The preferred number to start indexing on.
	 */
	let _extimateStartIndex = function () {
		
		// currentPage is so low, we should start at the beginning.
		if ( settings.currentPage <= 2 ) {
			return 0;
			
			// currentPage is so high, we should start at the end.
		} else if ( settings.currentPage + 2 >= settings.totalPages - 1 ) {
			return settings.totalPages - 5;
			
			// currentPage must be in the middle, create buttons from -2 to +2
		} else {
			return settings.currentPage - 2;
		}
	};
	
	/**
	 * Creates a single pagination index.
	 * @return {object}  A pagination object describing the button context.
	 */
	let _createPaginationIndex = function ( param ) {
		
		// handle param as a string:
		let n,
			visible,
			reader,
			active,
			disabled;
		
		// if the param is a text-string:
		if ( _.isString( param ) ) {
			
			switch ( param ) {
				
				case 'first' :
					n       = 0;
					visible = '&laquo;';
					reader  = T.tc('Pagination', 'First page');
					break;
				
				case 'prev' :
					n       = settings.currentPage - 1;
					visible = '&lsaquo;';
					reader  = T.tc('Pagination', 'Previous page');
					break;
				
				case 'next' :
					n       = settings.currentPage + 1;
					visible = '&rsaquo;';
					reader  = T.tc( 'Pagination', 'Next page' );
					break;
				
				case 'last' :
					n       = settings.totalPages - 1;
					visible = '&raquo;';
					reader  = T.tc('Pagination', 'Last page');
					break;
				
				default:
					console.error( '[PaginationStrip]: Could not recognize "%s" as a valid pagination index parameter.'.replace( '%s', param ) );
			}
			
			visible = '<span class="symbol">%s</span>'.replace( '%s', visible );
			
			// correct potential 'prev' and 'next' out of bounds indices.
			if ( n > settings.totalPages - 1 ) {
				n = settings.totalPages - 1;
			}
			
			if ( n < 0 ) {
				n = 0;
			}
			
			// directional buttons cannot be active.
			active = false;
			
			// and get disabled when pointing to the current page, or pointing out of bounds.
			disabled = ( n < 0 || n >= settings.totalPages || n === settings.currentPage );
			
			// when the param isn't a string, just set easy vars
		} else {
			n       = param;
			visible = n + 1;
			reader  = T.tc('Pagination', 'Page: %s' );
			active = ( n === settings.currentPage ),
			disabled = false; // numerical buttons are never disabled
		}
		
		// gather the object and return
		return {
			pageId     : n,
			active     : active,
			disabled   : disabled,
			textVisible: visible,
			textReader : reader.replace( '%s', n + 1 ),
		};
		
	};
	
	// html creation
	
	/**
	 * Puts together the whole pagination-html based on the array of paginationItems.
	 * @param  {array}  arrPagination  The array of pagination items to make the html from.
	 * @return {string}                A html representation of all the pagination buttons as a list.
	 */
	let _createPaginationHtml = function ( arrPagination ) {
		
		let html5 = '';
		
		_.each( arrPagination, function ( object ) {
			html5 += _createPaginationButtonHtml( object );
		} );
		
		return html5;
		
	};
	
	/**
	 * Create a single pagination button based on a paginationItem object.
	 * @param  {object} objPage  An object representing all you need to make a pagination button.
	 * @return {string}          A string representation of said object.
	 */
	let _createPaginationButtonHtml = function ( objPage ) {
		
		let active = ( objPage.active )
					 ? ' class="active"'
					 : '';
		
		let disabled = ( objPage.disabled )
					   ? ' disabled'
					   : '';
		
		let html5 = '';
		
		
		html5 += '<li%s1>';
		html5 += '<a href="#" class="pagination-button button" data-click="pagination-button" data-id="%s2"%s3>';
		html5 += '<span aria-hidden="true">%s4</span>';
		html5 += '<span class="screen-reader-text">%s5</span>';
		html5 += '</a>';
		html5 += '</li>';
		
		return html5
			.replace( '%s1', active )
			.replace( '%s2', objPage.pageId )
			.replace( '%s3', disabled )
			.replace( '%s4', objPage.textVisible )
			.replace( '%s5', objPage.textReader );
		
	};
	
	
	init();
	return this;
};

export default PaginationStrip;